var React = require('react');

function ArcBottomIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M87.1481 5.72878C87.1481 5.72878 35.6051 23.9239 2.22472 12.211","stroke":"white","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M43.2727 2.86944C43.2727 2.86944 17.2594 6.89643 7.09739 1.84694","stroke":"white","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArcBottomIcon.defaultProps = {"width":"89","height":"21","viewBox":"0 0 89 21","fill":"none"};

module.exports = ArcBottomIcon;

ArcBottomIcon.default = ArcBottomIcon;
